/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `Wir haben nur wenige Unterkünfte gefunden, die Ihrer Suche entsprechen. Weitere Unterkünfte finden Sie unter`
};

const en_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `We haven't found much accommodation that match your search. For more choice, go to`
};

const es_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `Hemos encontrado pocos alojamientos que coincidan con tu búsqueda. Para más opciones, visita`
};

const fr_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `Nous avons trouvé peu d'hébergements qui correspondent à votre recherche. Pour plus de choix, rendez-vous sur`
};

const it_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `Non abbiamo trovato molti sistemazioni che corrispondono alla tua ricerca. Per una scelta più ampia, visita`
};

const nl_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `We hebben niet veel accommodaties gevonden die aan uw zoekcriteria voldoen. Ga voor meer accommodatie naar`
};

const pt_view_more__on = /** @type {(inputs: {}) => string} */ () => {
	return `Encontrámos poucos alojamentos que correspondam aos seus critérios de pesquisa. Para mais opções, consulte`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.view_more__on(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("view_more__on", locale)
	if (locale === "de") return de_view_more__on(inputs)
	if (locale === "en") return en_view_more__on(inputs)
	if (locale === "es") return es_view_more__on(inputs)
	if (locale === "fr") return fr_view_more__on(inputs)
	if (locale === "it") return it_view_more__on(inputs)
	if (locale === "nl") return nl_view_more__on(inputs)
	return pt_view_more__on(inputs)
};